export let SortByOption;

(function (SortByOption) {
  SortByOption["Relevance"] = "relevance";
  SortByOption["PriceHighToLow"] = "price_high_to_low";
  SortByOption["PriceLowToHigh"] = "price_low_to_high";
  SortByOption["NewestFirst"] = "newest_first";
})(SortByOption || (SortByOption = {}));

export const SELECT_DROPDOWN_MAX_HEIGHT = 320;
export const SELECT_DROPDOWN_MIN_WIDTH = 300;